import DENTToothPeriodontalLineSingle, {
	PeriodontalLinePoint,
} from './DENTToothPeriodontalLineSingle';
import DENTToothPeriodontalLineFill from './DENTToothPeriodontalLineFill';
import React from 'react';

interface SizeProps {
	w: number;
	h: number;
}

interface Props {
	viewBox: SizeProps;
	containerSize: SizeProps;
	isUp: boolean;
	depthPoints: PeriodontalLinePoint[];
	marginPoints: PeriodontalLinePoint[];
}

const DENTToothPeriodontalLines = ({
	viewBox,
	containerSize,
	isUp,
	depthPoints,
	marginPoints,
}: Props) => {
	return (
		<svg
			viewBox={`0 0 ${viewBox.w} ${viewBox.h}`}
			preserveAspectRatio='xMidYMid meet'>
			<g
				transform={
					isUp
						? `translate(${containerSize.w}, ${containerSize.h}) scale(1, -1)`
						: undefined
				}>
				<DENTToothPeriodontalLineSingle
					points={depthPoints}
					width='1.5'
					color='#3AA8DF'
				/>
				<DENTToothPeriodontalLineSingle
					points={marginPoints}
					width='2'
					color='#E34942'
				/>
				<DENTToothPeriodontalLineFill
					marginPoints={marginPoints}
					depthPoints={depthPoints}
				/>
			</g>
		</svg>
	);
};

export default DENTToothPeriodontalLines;
